import React from "react";

import { DivEmbedder } from "./DivEmbedder";
import { ShadowEmbedder } from "./ShadowEmbedder";

export type ChildProps = {
  content: string;
};

type Props = ChildProps & {
  useShadowDom?: boolean;
};

export const cleanupHTMLContent = (content: string) =>
  content
    .replace(/<meta(?:.*?)(?:\/>|>(?:.*?)<\/meta>)/g, "")
    .replace(/<title(?:.*?)(?:\/>|>(?:.*?)<\/title>)/g, "");

export const EmbeddedContent = ({ useShadowDom = false, content }: Props) => {
  // strip unwanted tags
  const newContent = cleanupHTMLContent(content);

  return useShadowDom ? (
    <ShadowEmbedder content={newContent} />
  ) : (
    <DivEmbedder content={newContent} />
  );
};
